import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  addServicePage,
  fetchAllServicePages,
  updateServicePage,
  deleteServicePage,
} from '../services/servicePages';
import './ServicePages.css';
import { city } from 'fontawesome';

const ServicePages = () => {
  const [addFaq, setAddFaq] = useState(false);
  const [question, setQuestion] = useState();
  const [answer, setAnswer] = useState();
  const [passwordPop, setPasswordPop] = useState(true);
  const [password, setPassword] = useState('');
  const [data, setData] = useState({
    city: '',
    heading: '',
    description: '',
    faq: [],
  });
  const [showAnswer, setShowAnswer] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [error, setError] = useState();
  const [actionPop, setActionPop] = useState(true);
  const [existingPages, setExistingPages] = useState([]);
  const [id, setId] = useState();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [logo, setLogo] = useState('');
  const [address, setAddress] = useState({
    streetAddress: '',
    addressLocality: '',
    addressRegion: '',
    addressCountry: '',
  });
  const [socialLinks, setSocialLinks] = useState(['']);
  const navigate = useNavigate();

  useEffect(() => {
    fetchServicePages();
  }, []);

  const handleSocialChange = (index, value) => {
    setSocialLinks((prevLinks) => {
      const updatedLinks = [...prevLinks];
      updatedLinks[index] = value;
      return updatedLinks;
    });
  };

  const addSocialLink = () => setSocialLinks((prevLinks) => [...prevLinks, '']);
  const seoHead = `
        <link rel="canonical" href={window.loaction.href} />
        <title>${title || ''}</title>
        <meta
          name="description"
          content=${description || ''}
        />
        <meta
          property="og:title"
          content=${title || ''}
        />
        <meta
          property="og:description"
          content=${description}
        />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content="https://www.beatmyinsurance.com/logo512.png"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Beat My Insurance" />
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta
          name="twitter:title"
          content=${title || ''}
        />{" "}
        <meta
          name="twitter:description"
          content=${description}
        />{" "}
        <meta
          name="twitter:image"
          content="https://www.beatmyinsurance.com/logo512.png"
        />{" "}
        <meta name="twitter:site" content="@Beatmyinsurance" />
  `;

  const seoSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    ...(name && { name }),
    ...(url && { url }),
    ...(logo && { logo }),
    ...(description && { description }),
    address: {
      '@type': 'PostalAddress',
      ...Object.fromEntries(
        Object.entries(address).filter(([_, v]) => v.trim() !== '')
      ),
    },
    sameAs: socialLinks.filter((link) => link.trim() !== ''),
    faqPage: {
      '@type': 'FAQPage',
      mainEntity: data.faq
        .filter(({ question, answer }) => question.trim() && answer.trim())
        .map(({ question, answer }) => ({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        })),
    },
  };

  const fetchServicePages = async () => {
    try {
      const result = await fetchAllServicePages();
      if (result.servicePages) {
        setExistingPages(result.servicePages);
      } else {
        alert(result.error || 'Something went wrong');
      }
    } catch (err) {
      alert('Something went wrong, please try again later');
    }
  };

  const handleNewFaqSubmit = () => {
    const faq = data.faq;
    faq.push({ question: question, answer: answer });
    setData({ ...data, faq: faq });
    setQuestion('');
    setAnswer('');
    setAddFaq(false);
  };
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordPop(false);
  };

  const handleAddPage = async () => {
    const finalData = {
      ...data,
      seo: {
        title: title.trim(),
        description: description.trim(),
        name: name.trim(),
        url: url.trim(),
        logo: logo.trim(),
        address: address,
        socialLinks: socialLinks,
        seoHead: seoHead,
        seoSchema: seoSchema,
      },
    };
    if (id) {
      try {
        const result = await updateServicePage(password, finalData, id);
        if (result.message) {
          alert('Successfully updated');
        } else if (result.error || result.password) {
          alert(result.error || result.password);
        }
      } catch (err) {
        setError('Something went wrong!');
      }
    } else {
      try {
        const result = await addServicePage(password, finalData);
        if (result.message) {
          alert('Successfully added');
        } else if (result.error || result.password) {
          alert(result.error || result.password);
        }
      } catch (err) {
        setError('Something went wrong!');
      }
    }
  };

  const handleViewEdit = (page, id) => {
    setId(id);
    if (page.seo) {
      const { seo: pageSeo, ...pageData } = page;
      setData(pageData);
      setTitle(pageSeo.title || '');
      setDescription(pageSeo.description || '');
      setName(pageSeo.name || '');
      setUrl(pageSeo.url || '');
      setLogo(pageSeo.logo || '');
      setAddress(
        pageSeo.address || {
          streetAddress: '',
          addressLocality: '',
          addressRegion: '',
          addressCountry: '',
        }
      );
      setSocialLinks(pageSeo.socialLinks || '');
    } else {
      setData(page);
    }
    setActionPop(false);
  };
  const handleDelete = async (id) => {
    try {
      const result = await deleteServicePage(password, id);
      if (result.message) {
        alert('Successfully deleted');
        setExistingPages(existingPages.filter((page) => page.id !== id));
        fetchServicePages();
      } else if (result.error || result.password) {
        alert(result.error || result.password);
      }
    } catch (err) {
      alert('Something went wrong, please try again later');
    }
  };

  const handleClosePasswordPopup = () => {
    setPassword('');
    setError('');
    navigate(-1);
  };

  return actionPop && !passwordPop ? (
    <div className="min-h-screen bg-[#f9fafb] p-6">
      <div className="relative mb-6 space-y-3 sm:space-y-0">
        <div className="flex flex-col gap-3 sm:hidden">
          <button
            onClick={() => navigate(-1)}
            className="
              inline-flex
              items-center
              gap-2
              px-3
              py-2
              rounded-md
              bg-gray-200
              text-gray-700
              text-sm
              font-medium
              hover:bg-gray-300
              transition
              w-fit
            "
          >
            <ArrowLeft size={16} />
            Back
          </button>

          <div className="flex justify-between items-center">
            <h1 className="text-xl font-semibold text-gray-800">
              Service Pages
            </h1>

            <button
              onClick={() => setActionPop(false)}
              className="px-3 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition"
            >
              + Add
            </button>
          </div>
        </div>

        <div className="hidden sm:flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="
              inline-flex
              items-center
              gap-2
              px-4
              py-2
              rounded-md
              bg-gray-200
              text-gray-700
              text-sm
              font-medium
              hover:bg-gray-300
              transition
            "
          >
            <ArrowLeft size={16} />
            Back
          </button>

          <h1 className="absolute left-1/2 -translate-x-1/2 text-xl font-semibold text-gray-800">
            Service Pages
          </h1>

          <button
            onClick={() => setActionPop(false)}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
          >
            + Add New Page
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {existingPages.map((page) => (
          <div
            key={page._id}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex flex-col justify-between"
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-4 truncate">
              {page.city}
            </h3>

            <div className="flex gap-3">
              <button
                onClick={() => handleViewEdit(page, page._id)}
                className="flex-1 opy-2 rounded-md bg-green-600 text-white text-sm font-medium hover:bg-green-700 transition"
              >
                View / Edit
              </button>

              <button
                onClick={() => handleDelete(page._id)}
                className="flex-1 py-2 rounded-md bg-red-500 text-white text-sm font-medium hover:bg-red-600 transition"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : passwordPop ? (
    <div className="password-popup">
      <h2>Enter Master Password</h2>
      <span
        onClick={handleClosePasswordPopup}
        role="button"
        aria-label="Close"
        className="
        absolute
        top-3
        right-3
      text-gray-600
        text-xl
        cursor-pointer
       hover:text-gray-800
        select-none
        "
      >
        ✕
      </span>
      <form onSubmit={handlePasswordSubmit}>
        <input
          type="password"
          placeholder="Master Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Submit</button>
      </form>
      {error && <p className="error-message">{error}</p>}
    </div>
  ) : (
    <div className="service-page">
      <div className="options">
        <button
          className="preview-btn"
          onClick={() => {
            setActionPop(true);
            setId(false);
            fetchServicePages();
            setData({
              city: '',
              heading: '',
              description: '',
              faq: [],
            });
            setShowPreview(false);
          }}
        >
          Go back
        </button>
        <button
          className="preview-btn"
          onClick={() => setShowPreview(!showPreview)}
        >
          {showPreview ? 'Edit' : 'Preview'}{' '}
        </button>
        <button onClick={() => handleAddPage()}>Upload changes</button>
      </div>
      <div className="service-page1">
        <h1 className="service-page1-head">
          Chasing cheap insurance in{' '}
          {!showPreview && (
            <>
              <input
                value={data.city}
                onChange={(e) => setData({ ...data, city: e.target.value })}
              />
            </>
          )}
          {showPreview && data.city}
        </h1>
        <div className="service-page1-container">
          <img src="./comments-service.png" alt="people comments" />
          <div className="service-page1-container-mid">
            <img src="./new-way.png" alt="new way" />
          </div>
          <div className="service-page1-container-end">
            <div>
              <div className="service-page-benefit-points">
                <img src="./green-tick.png" alt="one form" />
                <p>One form</p>
              </div>
              <div className="service-page-benefit-points">
                <img src="./green-tick.png" alt="easy sharing" />
                <p>Easy Sharing</p>
              </div>
              <div className="service-page-benefit-points">
                <img src="./green-tick.png" alt="multiple offers" />
                <p>Multiple Offers</p>
              </div>
            </div>
            <div className="service-page-list-for-free">
              <button onClick={() => navigate('/buy-insurance')}>
                List for FREE now!
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="how-it-works-container">
        <h2>How it Works</h2>
        <div className="how-it-works-container-content">
          <div className="how-it-works-container-content-left">
            <img src="./car-service.png" alt="how it works" />
            <p className="service-page-for-buyers">For Buyers</p>
            <p className="service-page-for-buyers-content">
              1. Add details <br />
              2. Share link or accept quote <br />
              3. Close the deal!
            </p>
            <p className="service-page-signup-text">Sign up for free now!</p>
            <div className="service-page-for-buyers-button">
              <button onClick={() => navigate('/buy-insurance')}>
                Start Listing
              </button>
            </div>
          </div>
          <div className="how-it-works-container-content-right">
            <img src="./sell-service.png" alt="how it works" />
            <p className="service-page-for-buyers">For Sellers</p>
            <p className="service-page-for-buyers-content">
              1. Sign up <br />
              2. Post quotes
            </p>
            <p className="service-page-signup-text">Sign up for free now!</p>
            <div className="service-page-for-buyers-button">
              <button onClick={() => navigate('/sell-insurance')}>
                View Leads
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="find-cheap-car-insurance-container">
        <div className="find-cheap-car-insurance-left">
          <h2>
            {!showPreview && (
              <input
                value={data.heading}
                onChange={(e) => setData({ ...data, heading: e.target.value })}
              />
            )}
            {showPreview && data.heading}
          </h2>
          <p>
            {!showPreview && (
              <textarea
                value={data.description}
                onChange={(e) =>
                  setData({ ...data, description: e.target.value })
                }
              />
            )}
            {showPreview && data.description}
          </p>
        </div>
        <div className="find-cheap-car-insurance-right">
          <div>
            <p>
              With this tool, know if your car is suitable for a good premium!
            </p>
            <button onClick={() => navigate('/cheap-insurance-car-finder')}>
              Cheap Insurance Car Calculator{' '}
            </button>
          </div>
          <div>
            <p>Compare insurance rate changes from these providers.</p>
            <button onClick={() => navigate('/car-insurance-rates-2025')}>
              Car Insurance Rates in 2025{' '}
            </button>
          </div>
        </div>
      </div>
      <div className="service-page-people-talks">
        <h2>What People are Talking About Insurance in {data.city}</h2>
        <div>
          {showPreview &&
            data.faq.map((faq, index) => (
              <div className="service-page-qa-item" key={index}>
                <div
                  className="service-page-question"
                  onClick={() => {
                    setShowAnswer(!showAnswer ? faq.question : null);
                  }}
                >
                  {faq.question}
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`service-page-chevron-icon ${
                      showAnswer === faq.question ? 'rotate' : ''
                    }`}
                  />
                </div>
                {showAnswer === faq.question && (
                  <div className="service-page-answer">{faq.answer}</div>
                )}
              </div>
            ))}
          {!showPreview && (
            <>
              {data.faq.map((faq, index) => (
                <div className="service-page-qa-item" key={index}>
                  <p>Question : {faq.question}</p>
                  <p>Answer : {faq.answer}</p>
                </div>
              ))}
              {!addFaq && (
                <button onClick={() => setAddFaq(true)}>+ Add FAQ</button>
              )}
              {addFaq && (
                <>
                  <label>Question</label>
                  <input
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                  />
                  <label>Answer</label>
                  <input
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                  />
                  <button onClick={() => handleNewFaqSubmit()}>Submit</button>
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div className="p-4 max-w-2xl mx-auto">
        {/*<Helmet>
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        <script type="application/ld+json">
          {JSON.stringify(seoSchema, null, 2)}
        </script>
      </Helmet>*/}
        <h2 className="text-xl font-bold mb-4">Dynamic SEO Generator</h2>
        <label>Title:</label>
        <input
          placeholder="Page Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <br />
        <label>Description</label>
        <textarea
          placeholder="Meta Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <br />
        <label>Organization Name</label>
        <input
          placeholder="Organization Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <br />
        <label>Website Url</label>
        <input
          placeholder="Website URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <br />
        <label>Logo URL</label>
        <input
          placeholder="Logo URL"
          value={logo}
          onChange={(e) => setLogo(e.target.value)}
          className="border p-2 w-full mb-2"
        />
        <h3 className="font-bold mt-4">Address</h3>
        <input
          placeholder="Street Address"
          value={address.streetAddress}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, streetAddress: e.target.value }))
          }
          className="border p-2 w-full mb-2"
        />
        <input
          placeholder="City"
          value={address.addressLocality}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, addressLocality: e.target.value }))
          }
          className="border p-2 w-full mb-2"
        />
        <input
          placeholder="Region"
          value={address.addressRegion}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, addressRegion: e.target.value }))
          }
          className="border p-2 w-full mb-2"
        />
        <input
          placeholder="Country"
          value={address.addressCountry}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, addressCountry: e.target.value }))
          }
          className="border p-2 w-full mb-2"
        />
        <h3 className="font-bold mt-4">Social Links</h3>
        {socialLinks.map((link, index) => (
          <input
            key={index}
            placeholder={`Social Link ${index + 1}`}
            value={link}
            onChange={(e) => handleSocialChange(index, e.target.value)}
            className="border p-2 w-full mb-2"
          />
        ))}
        <button
          onClick={addSocialLink}
          className="bg-blue-500 text-white p-2 rounded"
        >
          Add Social Link
        </button>

        <br />
        <p>
          {seoHead}
          <br />
          {JSON.stringify(seoSchema, null, 2)}
        </p>
      </div>
    </div>
  );
};
export default ServicePages;
